import $i from "~/i18n";
import * as actions from "./actions";
import * as mutations from "./mutations";

export default {
  namespaced: true,
  state: () => ({
    listNavbar: [
      {
        text: $i.t("menu.home"),
        path: "/"
      },
      {
        text: $i.t("menu.tuition"),
        path: "/v1/teaching"
      },
      {
        text: $i.t("menu.mags"),
        path: 'http://blog.madya.ir',
        external: true
      },
      {
        text: $i.t("menu.about"),
        path: "/v1/about"
      },
      /*    {
           text: 'فرم پرداخت',
           path: 'https://pay.madia.ir',
           external:true
         }, */
    ],
    listAvatar: [
      {
        text: $i.t("dashboardMenu.dashboard"),
        path: "/dashboard/profile"
      },
      {
        text: $i.t("menu.myCourses"),
        // path: '/my-courses'
        path: "/dashboard/mycourses"
      }
    ],
    isNavbar: false,
    isAvatar: false,
    navActive: ""
  }),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/navbar/index.js